import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.jsx'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: import.meta.env.PROD,
  environment: __APP_ENV__,
  release: __APP_VERSION__,
  beforeSend(event) {
    // Nunca enviar PINs ni credenciales de sync
    if (event.request?.data) {
      delete event.request.data.pin
      delete event.request.data.syncPass
    }
    return event
  },
})

const ErrorFallback = () => (
  <div style={{ padding: 24, color: '#f87171', fontFamily: 'monospace', background: '#111827', minHeight: '100vh' }}>
    <h2 style={{ color: '#fbbf24' }}>Error al iniciar PractiCaja</h2>
    <p style={{ color: '#9ca3af' }}>El error fue reportado automáticamente. Recarga la página o limpia el caché.</p>
  </div>
)

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
